import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import type { LoginAvatar, PublicLoginComposition } from "@htzap/contracts";
import { api, jsonBody } from "../../lib/api";
import { LoginAvatarCanvas } from "./LoginAvatarCanvas";

function isCompleteEmail(value: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}

export function LoginTeamGallery({ email }: { email: string }) {
  const [selectedAsset, setSelectedAsset] = useState<string | null>(null);
  const [breakpoint, setBreakpoint] = useState<"base" | "mobile">(() => window.innerWidth <= 1000 ? "mobile" : "base");
  const composition = useQuery({
    queryKey: ["login-composition", "public"],
    queryFn: () => api<PublicLoginComposition>("/v1/login-composition/public"),
    retry: false,
    staleTime: 60_000
  });

  useEffect(() => {
    const update = () => setBreakpoint(window.innerWidth <= 1000 ? "mobile" : "base");
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  useEffect(() => {
    setSelectedAsset(null);
    if (!isCompleteEmail(email)) return;
    const controller = new AbortController();
    const timer = window.setTimeout(() => {
      void api<{ avatarId: string | null }>("/v1/auth/avatar-match", {
        method: "POST",
        signal: controller.signal,
        ...jsonBody({ email })
      }).then((result) => setSelectedAsset(result.avatarId)).catch(() => setSelectedAsset(null));
    }, 260);
    return () => {
      window.clearTimeout(timer);
      controller.abort();
    };
  }, [email]);

  return (
    <div className="login-team-gallery" role="img" aria-label="Equipe HelpTech reunida">
      <div className="login-team-stage login-team-stage-composed" aria-hidden="true">
        <LoginAvatarCanvas avatars={composition.data?.avatars as LoginAvatar[] || []} breakpoint={breakpoint} highlightedId={selectedAsset} />
      </div>
    </div>
  );
}
